export default "__VITE_ASSET__nqafG6zm__"